<div class="vh-100 d-flex justify-content-center align-items-center">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
                <div class="card">
                    <div class="card-body p-5">
                        <div>
                            <img src="assets/images/logo.png" style="width: 5rem;">
                            <h2 class="d-inline-block ms-2" style="position: relative; top: 0.5rem;" i18n>Nuuduu Media</h2>
                          </div>
                        <div class="input-group float-end" style="width: 10rem; position: relative; top: -1rem;">
                            <span class="input-group-text"><fa-icon [icon]="fa.faGlobe"></fa-icon></span>
                            <select [(ngModel)]="activeLocale" class="form-control" (change)="language()">
                                <option *ngFor="let locale of environment.locales" [ngValue]="locale">{{ locale| i18nSelect: locales }}</option>
                            </select>
                        </div>
                        <form class="mb-3 row mt-md-4" [formGroup]="signupForm" (ngSubmit)="signup()">
                            <h3 i18n>Signup</h3>
                            <p i18n>Enter your details below to create Nuuduu Media account.</p>
                            <p i18n>Nuuduu Media is platform for advertisers to reach Nuuduu users.</p>
                            <div class="mb-3 col-12">
                                <label for="organization_name" class="form-label" i18n>Organization name</label>
                                <input type="text" class="form-control" id="organization_name"
                                    formControlName="organization_name">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label for="first_name" class="form-label" i18n>First name</label>
                                <input type="text" class="form-control" id="first_name" autocomplete="given-name"
                                    formControlName="first_name">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label for="last_name" class="form-label" i18n>Last name</label>
                                <input type="text" class="form-control" id="last_name" autocomplete="given-name"
                                    formControlName="last_name">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label for="email" class="form-label" i18n>Email address</label>
                                <input type="email" class="form-control" id="email" autocomplete="username"
                                    formControlName="email">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label for="mobile_phone" class="form-label" i18n>Phone number</label>
                                <input type="tel" class="form-control" id="email" autocomplete="tel"
                                    formControlName="mobile_phone">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label for="password" class="form-label" i18n>Password</label>
                                <input type="password" class="form-control" id="password"
                                    autocomplete="new-password" formControlName="password">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label for="confirm_password" class="form-label" i18n>Confirm password</label>
                                <input type="password" class="form-control" id="confirm_password"
                                    autocomplete="new-password" formControlName="confirm_password">
                            </div>
                            <div class="d-grid">
                                <button [disabled]="!signupForm.valid" class="btn btn-primary" type="submit"
                                    i18n>Signup</button>
                            </div>
                            <p class="text-center mt-3">
                                <a routerLink="/login" i18n>Back to login</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>